module.exports = __webpack_public_path__ + "img/logo.c5d0e7a6.png";